export default __webpack_public_path__ + "static/media/mexico.5a97f4f6.svg";